import './style.css';
import { Popconfirm } from "antd";
import { useDispatch } from "react-redux";
// import { useHistory } from "react-router";
import { getallInvestor } from "../../actions";
import React, { useState, useEffect } from "react";
import coverImage from "../../../../coverImage.jpg"

const networkStatus = [
  {
    name: "Pending",
    id: 0
  },
  {
    name: "Accepted",
    id: 1
  },
  {
    name: "Rejected",
    id: 2
  },
  {
    name: "Blocked",
    id: 3
  }
]
const ProfileHeader = ({ fundProfileDetails, id, createAllocatorNetwork, updateAllocatorNetwork, deleteAllocatorNetworks }) => {

  // const history = useHistory();
  const dispatch = useDispatch();
  const [coverImg, setCoverImg] = useState();
  const [companyLogo, setCompanyLogo] = useState();

  const { 
    profileDetails, 
    // loading, 
    // getAllInvestors, 
    // coverImageUrl, 
    // companyLogoUrl 
  } = fundProfileDetails;
  useEffect(() => {
    dispatch(getallInvestor())
    setCoverImg(profileDetails?.coverImageUrl ? profileDetails?.coverImageUrl : coverImage);
    setCompanyLogo(profileDetails?.logo ? profileDetails?.logo : "./assets/images/empty-avatar.png")
  }, [profileDetails]);

  const createNetwork = (status) => {
    const Obj = {
      status: status,
      receiverId: Number(id)
    }
    createAllocatorNetwork(Obj)
  }
  const updateNetwork = (status, id) => {
    const Obj = {
      id: id,
      status: status,
      receiverId: Number(id)
    }
    updateAllocatorNetwork(Obj);
  }
  const deleteNetwork = (id) => {
    deleteAllocatorNetworks(id)
  }

  return (
    <div className="cover-profile">
      <div>
        <img className="profile-bg-img img-fluid" style={{ height: "300px" }} src={coverImg} alt="Cover Image" />
        <div className="card-block user-info">
          <div className="col-md-12" style={{ marginTop: "40px" }}>
            <div className="media-left">

              <div className="profile-image overlay-container">
                {/* <div className="overlay">
                  <i className="fa fa-pencil icon-action overlay-content" title="Change Company Logo" onClick={() => setOpenLogo(true)}></i>
                </div> */}
                <img className="profile-pg-img" src={companyLogo} alt="Profile Image" />
              </div>
            </div>
            <div className="media-body row">
              <div className="col-lg-12">
                <div className="user-title">
                  <h2 style={{ color: '#ffffff' }}><a href={profileDetails?.websiteUrl} >{profileDetails?.name}</a></h2>
                  <span className="text-white">{profileDetails?.address}</span>
                </div>
              </div>
            </div>
            <div className="pull-right cover-btn" >
              <div className="row" style={{ height: '50px' }}>
                {(() => {
                  if (networkStatus[0].id === profileDetails.recieverNetwork?.status) {
                    return (
                      <div>
                        <Popconfirm
                          title={profileDetails.name}
                          description="Are you sure to cancel it?"
                          onConfirm={() => deleteNetwork(profileDetails?.recieverNetwork?.id)}
                        >
                          <button className="btn btn-primary m-r-10 m-b-5" >
                            <i className="fa fa-plus mr-1" ></i>
                            Pending
                          </button>
                        </Popconfirm>
                      </div>
                    )
                  } else if (networkStatus[0].id === profileDetails.senderNetwork?.status) {
                    return (
                      <div>
                        <button onClick={() => updateNetwork(networkStatus[1].id, profileDetails.senderNetwork.senderId, profileDetails?.senderNetwork?.id)}
                          className="btn btn-primary m-r-10 m-b-5"
                        >
                          <i className="fa fa-plus mr-1"></i>
                          Accept
                        </button> {" "}
                        <button onClick={() => updateNetwork(networkStatus[2].id, profileDetails.senderNetwork.senderId, profileDetails?.senderNetwork?.id)}
                          className="btn btn-primary m-r-10 m-b-5"
                        >
                          <i className="fa fa-plus mr-1"></i>
                          Reject
                        </button>
                      </div>
                    )
                  } else if (networkStatus[1].id === profileDetails.recieverNetwork?.status || networkStatus[1].id === profileDetails.senderNetwork?.status) {
                    return (
                      <div>
                        <Popconfirm
                          title={profileDetails.name}
                          description="Are you sure you want to remove it?"
                          onConfirm={() => deleteNetwork(profileDetails?.recieverNetwork !== null ? profileDetails?.recieverNetwork?.id : profileDetails?.senderNetwork?.id)}
                        >
                          <button className="btn btn-primary m-r-10 m-b-5">
                            <i className={"fa fa-plus-square mr-1"} style={{ color: "white" }}></i>
                            Connected
                          </button>
                        </Popconfirm> {" "}
                        <button
                          className="btn btn-primary m-r-10 m-b-5"
                        >
                          <i className="fa fa-plus mr-1"></i>
                          Message
                        </button>
                      </div>
                    )
                  } else if (profileDetails.recieverNetwork === null || profileDetails.senderNetwork === null) {
                    return (
                      <div>
                        <button onClick={() => createNetwork(networkStatus[0].id)}
                          className="btn btn-primary m-r-10 m-b-5">
                          <i className="fa fa-plus mr-1"></i>
                          Connect
                        </button>
                      </div>
                    )
                  } else if (networkStatus[3].id === profileDetails.recieverNetwork?.status || networkStatus[3].id === profileDetails.senderNetwork?.status) {
                    return (
                      <div>
                        <button onClick={() => updateNetwork(networkStatus[1].id, profileDetails?.senderNetwork?.receiverId, profileDetails.id)}
                          className="btn btn-primary m-r-10 m-b-5"
                        >
                          <i className="fa fa-plus mr-1"></i>
                          Blocked
                        </button>
                      </div>
                    )
                  }
                })()}
              </div>
              {/* <button type="button" className="btn btn-primary m-r-10 m-b-5">
                <i className="fa fa-comments mr-2" style={{ marginRight: "10px!important" }}></i> Message
              </button>{" "} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
